'use client';

import React, { useState } from 'react';
import { CatalogItem } from '@jucy-ui/common';
import { Theme } from '@mui/material';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import { SxProps } from '@mui/system/styleFunctionSx';
import { JucyMuiTabPanel } from '../../../../../Tabs';
import { FloorplansCarousel } from '../FloorplansCarousel/FloorplansCarousel';
import { FloorplansLightBox } from '../FloorplansCarousel/FloorplansLightBox';
import { getFleetCategoryDetailsDialogTabPanelProps } from './fleetCategoryDetailsDialogTabConsts';

export const SpecsTab: React.FC<{ activeTab: string; catalogItem: CatalogItem; sx?: SxProps<Theme> }> = ({ activeTab, catalogItem, sx }) => {
    const [index, setIndex] = useState<number>();
    return (
        <JucyMuiTabPanel activeValue={activeTab} {...getFleetCategoryDetailsDialogTabPanelProps('specs')} sx={sx}>
            <Box sx={{ pt: 2, '& :first-child': { mt: 0 } }} dangerouslySetInnerHTML={{ __html: catalogItem.specificationsDescription || '' }} />
            <Table sx={{ mt: 2, mb: 2 }} size="small">
                <TableBody>
                    {Object.entries(catalogItem.specifications).map(([key, value]) => (
                        <TableRow hover={true} key={key}>
                            <TableCell sx={{ fontWeight: 'bold' }}>{key}</TableCell>
                            <TableCell className="border-bottom">{value}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {catalogItem.floorPlans?.length ? (
                <>
                    <Typography
                        sx={{
                            fontWeight: '700',
                            typography: 'subtitle2',
                            mt: 1,
                        }}
                    >
                        Floor plans
                    </Typography>
                    <FloorplansLightBox
                        title={`${catalogItem.name} floor plans`}
                        index={index}
                        setIndex={setIndex}
                        floorplans={catalogItem.floorPlans || []}
                    />
                    <FloorplansCarousel
                        floorplans={catalogItem.floorPlans || []}
                        onFloorplanClicked={(_floorplan, index) => {
                            setIndex(index);
                        }}
                    />
                </>
            ) : null}
        </JucyMuiTabPanel>
    );
};
